import {
  ApplicationSubtype,
  AppPageContentWrapper,
  CircularTextLoader,
  PageContentBox,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";
import { resetSeOfficialNoteRequest } from "../../../../store/redux/slice/Forms/seOfficialNoteForm";

const SeOfficialNoteNew = () => {
  const dispatch = useAppDispatch();

  const seOfficialNoteForm = useAppSelector((state) => {
    return state.Forms.SEOfficialNoteForm;
  });

  useEffect(() => {
    dispatch(resetSeOfficialNoteRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {seOfficialNoteForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={seOfficialNoteForm.steps}
              applicationSubtype={ApplicationSubtype.SE_RECOGNITION}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default SeOfficialNoteNew;
